module.exports = __webpack_public_path__ + "static/media/month_10.95046565.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/month_10.png
// module id = 1681
// module chunks = 1